import axios from "axios";
import { SERVER_URL } from "config";

const request = axios.create({
  baseURL: SERVER_URL,
  timeout: 1000000,
});

export default request;
